export const status = {
  ATTENDING: 0,
  NOT_ATTENDING: 1,
  MAYBE: 2,
}
